export default __webpack_public_path__ + "static/media/Certn.3e7bd8bf.svg";